import type { FaireProductEntity } from "../../entity_types/product";

export const p_wfzbxbpnzj: FaireProductEntity = {
  token: "p_wfzbxbpnzj",
  type: "product",
  name: "Apple a Day Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/31564d8fc7e054124652e28f3bc61e248bc34529ed34e3b80c7b7cf2a4879834.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f62f4326eb7a28003aacff217b9d8279adca6b05bd4e40ee27e53a6a598dc0b.jpeg",
    "https://cdn.faire.com/fastly/894e98d416bbfccf7fe67ef68b0ecf63742e044fa98fa03f71efe18ee8ebad6c.jpeg",
  ],
  priceDollars: 11,
  description:
    "A lot of pressure we have put on this fruit, to suggest they are only thing you need to keep doctors away. So our thanks, heartfelt, goes to the apples.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:17.474Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
